import { Skeleton } from '../../../components';
import { useLang } from '../../../i18n';
import type { CompanyStat } from '../../../types';
import { resolveIcon } from '../hooks/useIcon';
import './HeroSection.scss';

export interface HeroSectionProps {
  stats: CompanyStat[];
  loading: boolean;
}

export default function HeroSection({ stats, loading }: HeroSectionProps) {
  const { t } = useLang();
  const visible = stats.slice(0, 4);

  return (
    <section className="about-hero">
      <div className="container about-hero__grid">
        <div className="about-hero__main">
          <span className="eyebrow about-hero__eyebrow">{t('about.eyebrow')}</span>
          <h1 className="about-hero__title">{t('about.hero.title')}</h1>
          <p className="lead about-hero__lead">{t('about.hero.lead')}</p>

          <div className="card-frame about-hero__stats" role="list">
            {loading && visible.length === 0
              ? [0, 1, 2, 3].map((i) => (
                  <div key={i} className="about-hero__stat" role="listitem">
                    <Skeleton width={36} height={36} shape="rect" />
                    <Skeleton width="70%" height={28} />
                    <Skeleton width="60%" height={12} />
                  </div>
                ))
              : visible.map((s) => {
                  const Icon = resolveIcon(s.icon_key);
                  return (
                    <div key={s.id} className="about-hero__stat" role="listitem">
                      <span className="about-hero__stat-icon" aria-hidden="true">
                        <Icon size={18} />
                      </span>
                      <span className="about-hero__stat-value">
                        {s.value}
                        {s.suffix ? <span className="about-hero__stat-suffix">{s.suffix}</span> : null}
                      </span>
                      <span className="about-hero__stat-label">{s.label}</span>
                    </div>
                  );
                })}
          </div>
        </div>
        <div className="about-hero__decor" aria-hidden="true">
          <div className="tech-pattern about-hero__pattern" />
        </div>
      </div>
    </section>
  );
}
